export default "__VITE_ASSET__DOh0i8sq__"